export default {
  zh: {
    user: '用户',
    register: '通过您的邀请码注册',
    recharge: '通过您的邀请码注册,并且已经消费。',
    time: '时间',
    description: '描述',
    ':': '：'
  },
  en: {
    user: 'Your friend ',
    register: ' use your invitation code to register.',
    recharge: ' use your invitation code to register and successfully purchase a plan.',
    time: 'Time',
    description: 'Description',
    ':': ': '
  }
}



// WEBPACK FOOTER //
// ./src/components/affiliate/friendRecords/lang.js